export default __webpack_public_path__ + "static/media/logo.b58e851f.png";